import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";

import Partner from './Partner';
import Footer from '../Footer';
import Header from '../Header';

import { userMenu, PartnersPage } from '../../../Constants/user';

import './style.scss';

class Partners extends PureComponent {
    constructor(props) {
        super(props);

        props.active(Object.keys(userMenu[0].menuList).findIndex(i => i === 'partners'));

        let firstLang = props.lang || 'en';
        let language = PartnersPage.find(el => el.lang === firstLang);

        document.title = language.title;

        this.state = {
            language,
            partners: [],
            lang: props.lang,
        };
    }

    async componentDidMount () {
        let { data: { result } } = await axios.post('/api/partners/getAll');

        this.setState({
            partners: result,
            initialized: true,
        });
    }

    static getDerivedStateFromProps(props, state) {
        let language = PartnersPage.find(el => el.lang === props.lang);
        document.title = language.title;

        return {
            ...state,
            language,
            lang: props.lang,
            initialized: true,
        }
    }

    render() {
        if (!this.state.initialized) return null;

        const { partners } = this.state;
        const { setLanguage, language, activeMenu, lang, width } = this.props;

        return (
            <div id={'partnersPage'}>
                <div id={'left'}>
                    {width > 1024 ? (
                        <Link to={'/'}><img src={'/images/userPage/desktop/Logo for web.png'} alt /></Link>
                    ) : (
                        <Link to={'/'}><img src={'/images/userPage/tablet/Logo2.png'} alt /></Link>
                    )}
                </div>
                <div id={'right'}>
                    <Header
                        userMenu={userMenu}
                        language={language}
                        active={activeMenu}
                        setLanguage={setLanguage}
                    />
                    <div id={'container'}>
                        <div id={'containerInner'}>
                            <div id={'textPart'}>
                                <div className={'partners'}>
                                {partners.map(({ id, src, link, data }) => (
                                    <Partner
                                        key={id}
                                        src={src}
                                        link={link}
                                        title={data.find(d => d.language === lang).name}
                                    />
                                ))}
                                </div>
                            </div>
                            <Footer language={language}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ main: { width } }) => ({
    width,
});

export default connect(mapStateToProps)(Partners);
